export enum DYNAMIC_PROCESS_FORM {
  MODEL = "base",
  PATH = "path",
  INITIATOR = "initiatrTemplate",
  APPROVER = "approverTemplate",
  TRIGGER = "trigger",
}
